import styled from 'styled-components';

export const FlagBackground = styled.div`
  display: flex;
  align-items: center;
  padding: 0.1rem 0.5rem;
  font-size: 0.625rem;
  text-transform: uppercase;
  text-shadow: none;
  color: ${Styles.color.white};
  overflow: hidden;
  background: ${Styles.color.primary};
  /* put the funky corners on the last flag in the parent wrapper */
  &:last-of-type {
    clip-path: polygon(0 0, 0 100%, 100% 100%, 90% 50%, 100% 0);
    padding-right: 1.25rem;
  }
`;

export const FlagLabel = styled.div`
  line-height: 1.1;
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.heavy};
`;
